import { getLocalTimeZone, today } from "@internationalized/date";
import { useMemo, useState } from "react";
import type { DateValue } from "react-aria";
import type { EventsMetricsParams } from "../types/events-metrics";

function createDefaultDateRange() {
	const tz = getLocalTimeZone();
	const nowDate = today(tz);
	return {
		start: nowDate,
		end: nowDate,
	};
}

export function useDashboardEventsMetricsDateState() {
	const defaultRange = useMemo(() => createDefaultDateRange(), []);
	const [startDate, setStartDate] = useState<DateValue>(defaultRange.start);
	const [endDate, setEndDate] = useState<DateValue>(defaultRange.end);

	const metricsParams = useMemo<EventsMetricsParams>(
		() => ({
			startDate: startDate.toString(),
			endDate: endDate.toString(),
		}),
		[startDate, endDate]
	);

	return {
		startDate,
		endDate,
		setStartDate,
		setEndDate,
		metricsParams,
	};
}
